<template lang="pug">
.full-height.card-image.pa-5
  upload-file(@dragging="isDragging = $event" @drop-files="dropFiles")
    v-scroll-y-transition(leave-absolute)
      .d-flex.flex-column.align-center.justify-center.fill-height(
        v-if="!loading"
        :class="{ dragging: isDragging }"
      )
        slot(name="main" v-bind="{ uploaded, pickFile }")
          v-icon(x-large).grey--text.text--darken-1 mdi-cloud-upload-outline
          p.text-center.my-4.grey--text.text--darken-1 Перенесите сюда файлы
          .caption.grey--text.text--darken-1
            v-icon.mr-1.grey--text.text--darken-1 mdi-information-outline
            | Максимальный размер файла не более {{ maxSize }}мб

        slot(v-if="uploaded.length" name="uploaded" v-bind="{ uploaded, pickFile }")
          .caption.grey--text.text--darken-1.text-center.mt-3()
            strong Загружено файлов {{ uploaded.length }}
            ul
              li(v-for="f in uploaded" :key="f.data.file_name") {{ f.data.file_name }}

        input(
          ref="fileInput"
          type="file"
          :multiple="multiple"
          :accept="accept"
          @change="onFilesPicked"
        ).visually-hidden
        slot(name="uploading-button" v-bind="{ pickFile }")
          app-button(
            rounded
            @click="pickFile"
          ).my-4 Выбрать файлы
    slot(v-if="loading" name="uploading" v-bind="{ loading, progress }")
      .text-center.pa-5.mt-5
        v-progress-linear(
          :value="progress"
          rounded
        )
        .caption Загрузка файла...
</template>

<script>
import UploadFile from '@/components/UploadFile.vue';
import { mbToBytes } from '@/helpers/bytes-convert';
import { EXTENSIONS } from '@/constants/filesExtensions';

export default {
  name: 'DragAndDrop',
  constants: {
    EXTENSIONS,
  },
  components: {
    UploadFile,
  },
  props: {
    multiple: { type: Boolean, default: false },
    accept: { type: String, default: 'image/*' },
    isUploading: { type: Boolean, default: false },
    uploadHandler: { type: Function, default: null },
    maxSize: { type: Number, default: 5 }, // mb
  },
  data() {
    return {
      files: [],
      uploaded: [],
      isDragging: false,

      loading: false,
      progress: 0,
      uploadFunction: this.uploadFile,
    };
  },
  watch: {
    loading() {
      this.$emit('update:isUploading', this.loading);
    },
  },
  created() {
    if (this.uploadHandler) this.uploadFunction = this.uploadHandler;
  },
  methods: {
    async onFilesPicked(e) {
      const { files } = e.target;
      this.files = Array.from(files);
      this.uploaded = [];
      this.progress = 0;
      if (this.maxSize) {
        this.files = this.files.filter(({ size, name }) => {
          const maxSize = mbToBytes(this.maxSize);
          const isPassed = !maxSize || size <= maxSize;
          if (!isPassed) {
            this.$toast.error(`Файл «${name}» слишком большой`);
          }

          return isPassed;
        });
      }
      this.loading = true;
      await this.uploadFiles().then((uploadFiles) => {
        if (this.uploadHandler && uploadFiles.length && !this.uploaded.length) {
          this.uploaded.push(...uploadFiles);
        }
      });
      this.loading = false;

      if (this.uploaded.length) {
        this.$emit('uploaded', this.uploaded);
      }
    },
    uploadFiles() {
      const bullets = this.files.map((file) => this.uploadFunction(file));
      return Promise.all(bullets).then((promisedBullets) => promisedBullets.filter(Boolean));
    },
    async uploadFile(file) {
      const args = [
        file,
        (progress) => {
          this.progress = progress;
        },
        this.maxSize,
      ];
      const { response, error } = await this.$rApi.upload.uploadFile({ args });
      if (error) {
        return undefined;
      }

      return this.uploaded.push({ data: response.data.data, file });
    },
    pickFile() {
      this.$refs.fileInput.click();
    },
    dropFiles(e) {
      e.target.files = e.dataTransfer.files;
      this.onFilesPicked(e);
    },
  },
};
</script>
